module.exports = __webpack_public_path__ + "static/media/_DSC1588.9fd3c77d.jpg";